export default {
  container: { display: "flex", flexDirection: "row" },

  iconContainer: {},
  icon: {
    width: "1.5rem",
    height: "1.5rem",
  },

  labelContainer: {
    marginLeft: 8,
    display: "flex",
    justifyContent: "center",
    alignSelf: "center",
  },

  label: {
    fontSize: "0.875rem",
  },

  labelChecked: {
    color: "black",
  },
};
